import React, { useEffect, useState } from 'react';
import { 
  useGroupCore, 
  useFacility, 
  useListing, 
  useError 
} from './contexts/GroupIntakeRootContext';

/**
 * Test component to validate our refactored group intake implementation
 */
const TestGroupIntake = () => {
  const [logs, setLogs] = useState([]);
  
  // Get all contexts
  const core = useGroupCore();
  const facility = useFacility();
  const listing = useListing();
  const error = useError();
  
  // Add a log message
  const addLog = (message) => {
    setLogs(prev => [...prev, `${new Date().toISOString().substring(11, 19)}: ${message}`]);
  };
  
  // Test function to update a group field
  const testUpdateGroup = () => {
    addLog('Testing group update...');
    core.updateGroupField('name', 'Test Group ' + Date.now());
  };
  
  // Test function to add a facility
  const testAddFacility = () => {
    addLog('Testing add facility...');
    facility.addFacility();
  };
  
  // Test function to update a facility
  const testUpdateFacility = () => {
    if (facility.facilities.length === 0) {
      addLog('No facilities to update');
      return;
    }
    
    addLog('Testing facility update...');
    facility.updateFacilityField(0, 'name', 'Test Facility ' + Date.now());
  };
  
  // We'll use the addListing button directly in the UI instead of a separate test function
  
  // Display loading and error states
  useEffect(() => {
    if (core.isLoading) {
      addLog('Core loading...');
    }
    
    if (facility.isLoading) {
      addLog('Facility loading...');
    }
    
    if (listing.isLoading) {
      addLog('Listing loading...');
    }
    
    if (error.autosaveStatus.message) {
      addLog(`Autosave status: ${error.autosaveStatus.message} (${error.autosaveStatus.type})`);
    }
  }, [core.isLoading, facility.isLoading, listing.isLoading, error.autosaveStatus]);
  
  // Log errors
  useEffect(() => {
    if (Object.keys(error.errors).length > 0) {
      addLog(`Errors: ${JSON.stringify(error.errors)}`);
    }
  }, [error.errors]);
  
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Group Intake Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Group Info</h2>
        <p>Group ID: {core.existingGroupId || 'New Group'}</p>
        <p>Group Name: {core.group.name || 'Not set'}</p>
        <p>Loading: {core.isLoading ? 'Yes' : 'No'}</p>
        <button 
          onClick={testUpdateGroup}
          style={{ padding: '8px 16px', marginRight: '10px' }}
        >
          Update Group Name
        </button>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Facilities ({facility.facilities.length})</h2>
        <button 
          onClick={testAddFacility}
          style={{ padding: '8px 16px', marginRight: '10px' }}
        >
          Add Facility
        </button>
        <button 
          onClick={testUpdateFacility}
          style={{ padding: '8px 16px' }}
        >
          Update First Facility
        </button>
        
        <div style={{ marginTop: '10px' }}>
          {facility.facilities.map((fac, index) => (
            <div key={fac.id || index} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
              <p><strong>Facility {index + 1}</strong>: {fac.name || fac.facilityName || 'Unnamed'}</p>
              <p>ID: {fac.id || 'No ID yet'}</p>
              <p>Listings: {fac.listings?.length || 0}</p>
              <button 
                onClick={() => listing.addListing(index)}
                style={{ padding: '8px 16px' }}
              >
                Add Listing
              </button>
            </div>
          ))}
        </div>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Debug Log</h2>
        <div style={{ 
          border: '1px solid #ccc', 
          padding: '10px', 
          backgroundColor: '#f5f5f5',
          height: '200px',
          overflowY: 'auto',
          fontFamily: 'monospace'
        }}>
          {logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestGroupIntake;
